import { removeItemFromBasket, updateBasketItem } from 'containers/OrderDetails/basketSlice'
import placeholder from 'assets/img/placeholder.png'
import ArrowBtn from 'components/buttons/ArrowBtn'
import GalleryModal from 'components/GalleryModal'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import { displayPrice } from 'utils/string'
import Popup from 'components/popups/Popup'
import { useReduxDispatch } from 'store'
import { PopupState } from '..'
import React from 'react'

interface ShopItemPopupProps extends shop.ShopItem {
  cartId?: string
  isEquipment: boolean
  isPhysicalShop: boolean
  basketItem?: basic.Form
  checkPrice?: basic.Form
  equipments?: basic.Object<shop.EquipmentItem>
  openPopup: (popup: PopupState) => void
}

const ShopItemPopup: React.FC<ShopItemPopupProps> = ({ cartId, isEquipment, isPhysicalShop, basketItem, equipments, checkPrice, openPopup, ...data }) => {
  const { id, name, description, photos, monthlyGrossPrice, grossPrice, piecesLeft, deliveryMethods, deliveryInfo } = data
  const { replace, goBack } = useHistory()
  const { t } = useTranslation('shop')
  const dispatch = useReduxDispatch()

  return (
    <Popup>
      <div className='shopItem__popup'>
        <div className='popup__title'>
          <div>{name}</div>
        </div>
        {photos && <GalleryModal
          onlyBody
          data={photos.length > 0
            ? photos
            : [{ document_title: name, public_path: placeholder, thumbnail: placeholder }]}
        />}
        <div className='group'>
          {monthlyGrossPrice
            ? <div className='shopItem__price'>{displayPrice(monthlyGrossPrice)} / {t('monthly')}</div>
            : <div className='shopItem__price'>{displayPrice(grossPrice)} / {t('once')}</div>}
          {piecesLeft && <div className='shopItem__warning'>
            {t('left')} {piecesLeft === 1 ? t('lastPiece') : `${piecesLeft} ${t('pieces')}!`}
          </div>}
        </div>
        <div className='shopItem__desc'>{description}</div>
        {deliveryInfo && <div className='shopItem__desc'>{deliveryInfo}</div>}
        <ArrowBtn
          enlarged
          text={t(
            isPhysicalShop
              ? 'openAShop'
              : isEquipment
                ? equipments?.[id]?.quantity ? 'removeFromRental' : 'addToRental'
                : basketItem ? 'removeFromCart' : 'addToCart')
          }
          action={() => {
            if (isEquipment) {
              if (!cartId) return
              const equipment = equipments?.[id]
              const couldBeRemoved = equipment?.quantity === 1 && !checkPrice?.equipment?.some((e: shop.EquipmentItem) => e.id === id && e.quantity > 0)
              if (couldBeRemoved) {
                const { [id]: _, ...equipment } = equipments || {}
                dispatch(updateBasketItem({
                  identifier: cartId,
                  values: { equipment }
                }))

              } else {
                dispatch(updateBasketItem({
                  identifier: cartId,
                  values: {
                    equipment: equipment
                      ? {
                        ...equipments,
                        [id]: {
                          ...equipment,
                          quantity: equipment.quantity ? 0 : 1
                        }
                      } : {
                        ...equipments,
                        [id]: {
                          id,
                          name,
                          quantity: 1,
                          icon: data.icon,
                          maxQuantity: data.maxAmount,
                          description: data.description,
                          categoryId: data.category,
                          isRemovable: true,
                          selectableOnly: !data.maxAmount,
                          unitMonthlyGrossPrice: data.monthlyGrossPrice,
                          unitMonthlyNetPrice: data.monthlyNetPrice
                        }
                      }
                  }
                }))
              }
              goBack()

            } else {
              if (isPhysicalShop) {
                replace(window.location.pathname, LOCATION_STATES.popup({ type: 'openShop' }))
              } else if (basketItem) {
                dispatch(removeItemFromBasket({ removeIdentifiers: [basketItem.identifier] }))
              } else if (deliveryMethods.length > 0) {
                openPopup({ type: 'delivery', data })
              } else {
                alert('Brak metod dostawy')
              }
            }
          }}
        />
        <BackBtn />
      </div>
    </Popup>
  )
}

export default ShopItemPopup